import { forwardRef, type ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const variantClass: Record<Variant, string> = {
  primary:
    'bg-[var(--color-ink)] text-[var(--color-paper)] hover:opacity-90 disabled:opacity-50',
  secondary:
    'bg-transparent text-[var(--color-text)] border border-[var(--color-border)] hover:bg-[var(--color-page)]',
  ghost:
    'bg-transparent text-[var(--color-text)] hover:bg-[var(--color-page)]',
  danger:
    'bg-[var(--color-red-tint)] text-[#a4322a] hover:opacity-90',
};

export const Button = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }
>(function Button({ variant = 'primary', className = '', ...rest }, ref) {
  return (
    <button
      ref={ref}
      className={[
        'inline-flex items-center justify-center gap-2',
        'h-10 px-4 rounded-[var(--radius-sm)]',
        'font-sans text-sm font-medium',
        'transition disabled:cursor-not-allowed',
        variantClass[variant],
        className,
      ].join(' ')}
      {...rest}
    />
  );
});
